import { h, Component } from 'preact';
import style from './style.less';

export default class LandingHome extends Component {
  render() {
    return <div>
      <section class={[style.display_section].join(' ')}>
        <div class="row">
          <div class="col col-12 col-sm-12 col-md-5">
            <h1>
              <span class={style.color_primary}>The simplest way</span><br/>
              to manage<br/>
              your contacts
            </h1>
            <p>
              Addy is a digital address book that collects and updates your contacts automatically,
              saving you time (and more than a few headaches).
            </p>
          </div>
          <div class={["col col-12 col-sm-12 col-md-7", style["bg-people-on-computers"], style.slide_image].join(' ')}>
          </div>
        </div>
      </section>
      <section>
        <div class="row mb-lg-5 mb-4">
          <div class={style.fill_vertical + " col col-12 col-lg-4"}>
            <h4 class={style.bubble_header + ' ' + style.header_weddings}>Weddings</h4>
            <div class={style.bubble}>
              <p>
              “Addy was super helpful when we were planning our wedding.
              Not having to text each of our guests individually to get their addresses saved us a lot of hassle.”
              </p>
              <div class={style.bubble_footer + ' ' + style.bubble_signature_rachel}>
                - Rachel Crowder
              </div>
            </div>
          </div>
          <div class={style.fill_vertical + " col col-12 col-lg-4"}>
            <h4 class={style.bubble_header + ' ' + style.header_moving}>Moving</h4>
            <div class={style.bubble}>
              <p>
              “I can’t imagine what moving across the country would have been like if I didn’t have Addy setup. ”
              </p>
              <div class={style.bubble_footer + ' ' + style.bubble_signature_chris}>
                - Chris Paul
              </div>
            </div>
          </div>
          <div class={style.fill_vertical + " col col-12 col-lg-4"}>
            <h4 class={style.bubble_header + ' ' + style.header_gifting}>Gifting</h4>
            <div class={style.bubble}>
              <p>
              “I love surprising my friends and family with presents for their birthdays.
              Before, texting them for their address ruined all the fun.”
              </p>
              <div class={style.bubble_footer + ' ' + style.bubble_signature_chelsea}>
              - Chelsea Pridget
              </div>
            </div>
          </div>
        </div>
      </section>
      <div class={style.section_container_shaded}>
        <section class={style.section_slide}>
          <div class="row flex-md-row-reverse">
            <div class="col-md-5">
              <h2 class={style.header_icon_connect}><span class={style.color_primary}>Collect addresses</span> from groups of friends & family in a few clicks</h2>
              <p>Whether you’re sending party invitations, holiday greetings, thank you cards, or birthday gifts,
              Addy ensures you always have the mailing info you need to get letters and packages to their intended destination,
              no matter how often your contacts move.</p>
            </div>
            <div class={"col-md-7 " + style.image_checkmail + " " + style.slide_image}></div>
          </div>
        </section>
      </div>
      <section class={style.section_slide}>
        <div class="row">
          <div class="col-lg-6">
            <h2 class={style.header_icon_confidence}><span class={style.color_primary}>Store contacts</span> with confidence that they’re up&#8209;to&#8209;date</h2>
            <div class={style.columns_2}>
              <div>
                <div class="font-weight-bold">Secure Address Requests</div>
                <div>Addy does the legwork of collecting addresses for you.</div>
              </div>
              <div>
                <div class="font-weight-bold">Two-Way Exchange</div>
                <div>You receive your contacts’ change of address updates, and they receive yours.</div>
              </div>
              <div>
                <div class="font-weight-bold">Birthday Reminders</div>
                <div>Get notified about contacts’ special days.</div>
              </div>
              <div>
                <div class="font-weight-bold">One-Click Gifting</div>
                <div>Send flowers, cards, and other tokens of appreciation without leaving the app.</div>
              </div>
              <div>
                <div class="font-weight-bold">List Management</div>
                <div>Group and organize contacts for specific events and mailings.</div>
              </div>
              <div>
                <div class="font-weight-bold">Easy Exporting</div>
                <div>Convert and send lists as spreadsheets without fuss.</div>
              </div>
            </div>
          </div>
          <div class={"col-lg-6 " + style.image_screengrab + " " + style.slide_image}></div>
        </div>
      </section>
      <div class={style.section_container_shaded}>
        <section class={style.section_slide}>
          <div class="row flex-md-row-reverse">
            <div class="col-md-5">
              <h2 class={style.header_icon_secure}>Your <span class={style.color_primary}>privacy</span> and <span class={style.color_primary}>security</span> are our priority</h2>
              <p>Rest assured, no one can access your contact information on Addy unless you give them permission.
              Period. Your name is not searchable, and we don’t sell your information to advertisers.</p>
            </div>
            <div class={"col-md-7 " + style.image_security + " " + style.slide_image}></div>
          </div>
        </section>
      </div>
      <section class={style.section_slide + " text-center"}>
        <h2 class={style.color_primary}>Build your Addy today!</h2>
        <p><b>Getting started is easy and free.</b> Enter your email address, and we’ll guide you&nbsp;through&nbsp;the&nbsp;rest.</p>
        <form class={style.form_get_started} action="join" method="get">
          <div class="form-row">
            <div class="col-md-8 pb-4">
              <input class="form-control form-control-lg" name="email" type="text" placeholder="Email Address" />
            </div>
            <div class="col-md-4">
              <button class={"btn btn-lg btn-mkjs-primary btn-block"}>GET STARTED</button>
            </div>
          </div>
        </form>
      </section>
    </div>
  }
}



// WEBPACK FOOTER //
// ./components/pages/landing/index.js